import { RowClickedEvent } from '@ag-grid-community/core'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SetSelectedColumns } from 'types/dataTable'
import { fetchPricings } from 'utils/api/pricingApi'
import { PAGE_PRICING_UPDATE } from 'utils/constants'
import { columns } from './utils'

interface PricingDataTableProps {
  isEditor: boolean
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const PricingDataTable = ({
  isEditor,
  setSelectedColumns,
  loading,
  setLoading,
}: PricingDataTableProps) => {
  const [pricingResponse, setPricingResponse] = useState<any>({})

  const navigate = useNavigate()
  const { search } = useLocation()
  const { getAllQueries, setQuery } = useQuery()

  // To fetch pricing Data
  const getPricingData = async () => {
    setLoading(true)
    const { limit, page, search, pricingFilters } = getAllQueries()
    try {
      const { data } = await fetchPricings({
        limit: limit || 10,
        page: page || 1,
        search: search,
        filters: pricingFilters,
      })

      setSelectedColumns(data?.tableConfig?.pricing || [])
      setPricingResponse({ ...data })
    } catch (error) {
      setPricingResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPricingData()
  }, [search])

  useEffect(() => {
    const columnUrlParams = localStorage.getItem('pricingColumnSelected')
    if (columnUrlParams) {
      setQuery('cols', JSON.parse(columnUrlParams))
    }
  }, [])

  // Will redirect to edit form
  const redirectToEdit = (e: RowClickedEvent) => {
    if (!isEditor) return
    navigate(`${PAGE_PRICING_UPDATE.path}/${e.data._id}`)
  }

  return (
    <>
      {/* Table */}
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : pricingResponse.docs}
        identifier="_id"
        onRowClicked={isEditor ? redirectToEdit : () => {}}
        activeColumns={pricingResponse?.tableConfig?.pricing || []}
        activeColumnsKey="pricing"
      />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={pricingResponse?.page}
        totalPages={pricingResponse?.totalPages}
        hasNextPage={pricingResponse?.hasNextPage}
        hasPrevPage={pricingResponse?.hasPrevPage}
        limit={pricingResponse?.limit}
        nextPage={pricingResponse?.nextPage}
        prevPage={pricingResponse?.prevPage}
        disabled={loading}
        shouldDisplayTotalPages={false}
        disableGoToLastPage
      />
    </>
  )
}

export default PricingDataTable
